<template>
  <div class="c-bar-chart">
    <p class="card-title">{{ title }}</p>
    <div v-for="(item, i) in rows" :key="i" class="bar-row">
      <div class="bar-label">{{ item.key }}</div>
      <div class="bar-track">
        <div class="bar-fill" :style="{ width: item.barW + '%', background: colors[i % colors.length] }"></div>
      </div>
      <div class="bar-meta">
        <span class="cnt">{{ item.val.toLocaleString() }}</span>
        <span class="pct">{{ item.pct.toFixed(1) }}%</span>
      </div>
    </div>
    <div class="respondents">Количество респондентов: {{ total.toLocaleString() }}</div>
  </div>
</template>

<script>
export default {
  name: 'CBarChart',
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colors: ['#378ADD', '#1D9E75', '#D4537E', '#BA7517', '#7F77DD', '#D85A30', '#639922', '#E24B4A'],
    }
  },
  computed: {
    total() {
      return Object.values(this.data).reduce((s, v) => s + v, 0)
    },
    max() {
      return Math.max(...Object.values(this.data))
    },
    rows() {
      return Object.entries(this.data).map(([key, val]) => ({
        key,
        val,
        pct: val / this.total * 100,
        barW: val / this.max * 100,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.c-bar-chart {
  border: 1px solid #e0e0e0;
  padding: 5px 10px 5px 10px;
  border-radius: 16px;
  .card-title {
    font-size: 18px;
    color: #000000;
    margin: 0 0 12px;
    font-weight: 400;
  }

  .bar-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 16px;

    .bar-label {
      width: 200px;
      flex-shrink: 0;
      color: #222;
      line-height: 1.3;
    }

    .bar-track {
      flex: 1;
      height: 18px;
      background: #f0f0f0;
      border-radius: 4px;
      overflow: hidden;

      .bar-fill {
        height: 100%;
        border-radius: 4px;
        transition: width 0.6s ease;
      }
    }

    .bar-meta {
      display: flex;
      gap: 6px;
      font-size: 16px;
      width: 80px;
      justify-content: flex-end;

      .cnt {
        color: #888;
      }

      .pct {
        font-weight: 500;
      }
    }
  }

  .respondents {
    font-size: 16px;
    color: #888;
    margin-top: 8px;
  }
}
</style>
